var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},_vm._l((_vm.secciones),function({componente, objeto},i){return _c(componente,{key:i,tag:"component",attrs:{"objeto":objeto}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }